// extracted by mini-css-extract-plugin
export default {"tintAccent":"styles_tintAccent__nAAn0","tintPremium":"styles_tintPremium__WgyrS","border":"styles_border__PHqHM","common":"styles_common__febQ5","spinner":"styles_spinner__s9IqH"};